import React, { type ReactNode, useEffect, useState } from 'react';

import { useRenderMode } from 'src/hooks/renderMode';

interface Props {
  children: ReactNode;
}

export const ClientOnly = ({ children }: Props) => {
  const renderMode = useRenderMode();

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => setHasMounted(true), []);

  return renderMode === 'client' && hasMounted ? <>{children}</> : null;
};
